import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
import { globalHistory } from '@/GlobalHistory';
import { App } from '@/App';
import { PagesRouting } from '@/Routing';
import { store } from '@/Redux/ConfigureStore';
import { NotificationSubscriptionInitializer } from '@/SignalR/Subscriptions';
import { OnlineArchiveNotificationSubscriptionInitializer } from '@/SignalR/Subscriptions';
import { hot } from 'react-hot-loader';
import { ToastContainerWrapper } from './Components/Toast/Toast';
import './Index.scss';
import '@/Extensions/NumberExtensions';
import { LoadingHandler } from '@/Services/LoadingHandler';
import { ErrorHandler } from '@/Services/ErrorHandler';
import { NumberFormatHandler } from '@/Services/NumberFormatHandler';
import { SignInPage } from '@/Pages/Authorization/SignIn/SignIn';
import { SignUpPage } from '@/Pages/Authorization/SignUp/SignUp';
import { EmailConfirmationPage } from '@/Pages/Authorization/EmailConfirmation/EmailConfirmation';
import { ResetPasswordPage } from '@/Pages/Authorization/ResetPassword/ResetPassword';
import { ChangePasswordPage } from '@/Pages/Authorization/ChangePassword/ChangePassword';

const taskSubscriptionInitializer = new NotificationSubscriptionInitializer(store.dispatch, store.getState);
const onlineArchiveHubSubscriptionInitializer = new OnlineArchiveNotificationSubscriptionInitializer(store.getState);

taskSubscriptionInitializer.initialize();
onlineArchiveHubSubscriptionInitializer.initialize();
// Singleton services initializing
// Need for correct work
ErrorHandler.start(store.getState);
LoadingHandler.start(store);
NumberFormatHandler.start(store.getState);

let Root = () => {
  return (
    <Provider store={store}>
      <ToastContainerWrapper />
      <Router history={globalHistory}>
        <Switch>
          <Route exact path={PagesRouting.AuthorizationPages.LoginPage} component={SignInPage} />
          <Route exact path={PagesRouting.AuthorizationPages.RegistrationPage} component={SignUpPage} />
          <Route exact path={PagesRouting.AuthorizationPages.EmailConfirmationPage} component={EmailConfirmationPage} />
          <Route exact path={PagesRouting.AuthorizationPages.ResetPasswordPage} component={ResetPasswordPage} />
          <Route exact path={PagesRouting.AuthorizationPages.ChangePasswordPage} component={ChangePasswordPage} />
          <Route path={'/'}>
            <App />
          </Route>
        </Switch>
      </Router>
    </Provider>
  );
};

if (module.hot) {
  Root = hot(module)(Root);
}

ReactDOM.render(<Root />, document.getElementById('app'));
